import React from 'react';
import cx from 'classnames';
import { Redirect, Switch, useLocation, Route } from 'react-router';

import {
  Border,
  HorizontalTabList,
  useModuleRoute,
} from 'spindl-shared-components';
import UserListPage from '../../pages/UserListPage';

import styles from './UserListLayout.module.scss';
import usePresenter from './UserListLayout.presenter';
import getProps from './UserListLayout.props';
import { UserListLayoutCombinedProps } from './types';
import WizardPage from '../../pages/WizardPage';

const UserListLayout: React.FC<UserListLayoutCombinedProps> = (props) => {
  const {
    className,
    classes,
    horizontalTabList,
    userListPage,
    wizardPage,
    border,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.userListLayout;

  const { pathname } = useLocation();
  const { modulePath } = useModuleRoute();

  return (
    <div className={cx(currentStyle, className)}>
      <HorizontalTabList
        className={cx(styles.horizontalTabList, classes?.horizontalTabList)}
        {...internalProps.horizontalTabList}
        {...horizontalTabList}/>
      <Border
        className={cx(styles.border, classes?.border)}
        {...internalProps.border}
        {...border}/>
      <Switch>
        <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
        <Route path={`${modulePath}/wizard`}>
          <WizardPage 
            className={cx(styles.wizardPage, classes?.wizardPage)}
            {...internalProps.wizardPage}
            {...wizardPage}/>
        </Route>
        <Route path={modulePath}>
          <UserListPage
            className={cx(styles.userListPage, classes?.userListPage)}
            {...internalProps.userListPage}
            {...userListPage}/>
        </Route>
      </Switch>
    </div>
  );
};

export default UserListLayout;
